import React from 'react';

import { Chart } from '../Chart';
import { LENS_COLORS_HEX, oldColors } from 'constants/colors';


export type DataItem = {
  name: string
  y: number
}


export type DonutProps = {
  seriesName?: string,
  title: string,
  data: DataItem[],
  hideLegend?: boolean,
};

export function Donut(props: DonutProps) {

  const isLensUI = Boolean(window.GLOBAL_CONFIG.FLIPPERS.LENS_UI)

  return <Chart
    title={props.title}
    config={{
      credits: {enabled: false},
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: !props.hideLegend,
          colors: isLensUI ? LENS_COLORS_HEX : oldColors,
        }
      },
      series: [{
        type: 'pie',
        name: props.seriesName || props.title,
        innerSize: '50%',
        data: props.data,
      }]
    }}
  />
}